import type { Ref } from "vue";
import type { CanvassTargetWithProgress } from "./types";

export function useCanvassTargets(
  canvassTargets: Ref<Array<CanvassTargetWithProgress>>,
) {
  const createCanvassTarget = () => {
    canvassTargets.value.push({
      id: globalThis.crypto.randomUUID(),
      description: "",
      target: 0,
      satisfiedTargets: 0,
    });
  };

  const deleteCanvassTarget = (canvassTarget: CanvassTargetWithProgress) => {
    canvassTargets.value = canvassTargets.value.filter(
      ({ id }) => id !== canvassTarget.id,
    );
  };

  return { createCanvassTarget, deleteCanvassTarget };
}
